import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
import { EnvironmentService } from '../../service/service.module';
import { Subject, Observable, of } from 'rxjs';
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class ChildItemService {

  environment = EnvironmentService.environment;

  // Subjects
  public childGridActionSubject: Subject<any> = new Subject();

  /* Set Subjects for HEADER COLUMN EDIT/REMOVE */
  setChildGridActionSubject = (value: any) => { this.childGridActionSubject.next(value); };

  // Observables
  getChildGridActionSubject = () => this.childGridActionSubject.asObservable();

  constructor(private http: HttpClient) {
  }

  CreateChildItem(masterItem: any) {
    return this.http.post<any>(`${this.environment.AppChildItem}/add`, masterItem)
      .pipe(map(data => {
        return data;
      }));
  }

  UpdateChildItem(masterItem: any) {
    return this.http.put(`${this.environment.AppChildItem}/update`, masterItem)
      .pipe(map(data => {
        return data;
      }));
  }

  DeleteChildItem(childItemId: string) {
    return this.http.delete(`${this.environment.AppChildItem}/delete?ChildItemId=${childItemId}`)
      .pipe(map(data => {
        return data;
      }));
  }

  GetAllChildItems(requestBody: any) {
    return this.http.post(`${this.environment.AppChildItem}/getall`, requestBody)
      .pipe(map(childItems => {
        return childItems;
      }));
  }

  GetAllChildItemByMasterItemId(masterItemId: any) {
    return this.http.get(`${this.environment.AppChildItem}/getlist?MasterItemId=${masterItemId}`)
      .pipe(map(childItems => {
        return childItems;
      }));
  }

  GetFilterChildItemList(body: any) {
    const query = Object.keys(body).map(key => {
      return `${key}=${body[key]}`;
    }).join('&');
    return this.http.get(`${this.environment.AppChildItem}/getlist?${query}`)
      .pipe(map(childItems => {
        return childItems;
      }));
  }

  ExportChildDataTemplate() {
    return this.http.get(`${this.environment.AppChildItem}/getexporttemplate`)
      .pipe(map(res => {
        return res;
      }));
  }

  ImportChildDataTemplate(body: any) {
    return this.http.post(`${this.environment.AppChildItem}/import`, body)
      .pipe(map(data => {
        return data;
      }));
  }

  UploadChildItemImage(body: any) {
    return this.http.post(`${this.environment.AppChildItem}/uploadimage`, body)
    .pipe(map(data => {
      return data;
    }));
  }


  RemoveChildItemImage(body: any) {
    return this.http.post(`${this.environment.AppChildItem}/removeImage`, body)
    .pipe(map(data => {
      return data;
    }));
  }

  upcValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (control.value.toString().length === 12) {
        return this.checkIfUPCExists(control.value).pipe(
          map(res => {
            // if res is true, username exists, return true
            return res ? { upcExists: true } : null;
            // NB: Return null if there is no error
          })
        );
      } else {
        return of(null);
      }
    };
  }

  checkIfUPCExists(upc: string) {
    return this.http.get(`${this.environment.AppChildItem}/validateupc?upc=${upc}`).pipe(map((res: any) => {
      return res;
    }));
  }

}
